import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import documents from './documents'
import accountStatus from './accountStatus'
import customer from './customer'
import users from './users'
import products from './products'
import cart from './cart'
import deductions from './deductions'
import orders from './orderNotes'
import intentions from './orderIntentions'
import sales from './salesNotes'
import notifications from './notifications'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        auth,
        documents,
        accountStatus,
        notifications,
        customer,
        products,
        users,
        orders,
        intentions,
        sales,
        cart,
        deductions
    }
})
